import { Link } from "react-router-dom";

export function BrandMark({ light = false, compact = false }) {
  const blueColor = light ? "text-white" : "text-brand-blue";
  const redColor = "text-brand-red";
  return (
    <Link to="/" className="flex items-center gap-2" data-testid="brand-mark">
      <div
        className={`p-2 rounded-lg ${
          light ? "bg-white text-brand-blue" : "bg-brand-blue text-brand-gold"
        }`}
      >
        <i className="fas fa-bolt text-lg" />
      </div>
      {!compact && (
        <span className={`text-xl md:text-2xl font-black tracking-tightest uppercase ${blueColor}`}>
          Party Rentals <span className={`italic ${light ? "text-brand-gold" : redColor}`}>Express</span>
        </span>
      )}
    </Link>
  );
}

export function EventismCredit({ inverted = false }) {
  return (
    <a
      href="https://eventism.com"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.3em] hover:opacity-80 transition-opacity ${
        inverted ? "text-white/80" : "text-slate-500"
      }`}
      data-testid="eventism-credit-link"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${inverted ? "bg-brand-gold" : "bg-brand-red"}`} />
      An Eventism Service
      <i className="fas fa-arrow-up-right-from-square text-[8px]" />
    </a>
  );
}
